/**
 * @ngdoc object
 * @name ServerCtrl
 * @requires $scope, $stateParams, signalProvider
 */

'use strict';

angular.module('pulse')
    .controller('ServerV2Ctrl',
    ['$scope', '$stateParams', '$signalProvider', '$state', '$log', '$timeout', 'pools',
        function ($scope, $stateParams, $signalProvider, $state, $log, $timeout, pools) {

            $log.info('Servers V2 Controller');
            $scope.servers = {};

            var addTile = [{name:'Add Server', id:'create'}];
            $scope.servers.list = addTile.concat(pools);

            $scope.servers.back = function() {
              $state.go('^');
            };

        }]);
